/*
 * Filter values available to query the order list
 */

export const filterData = (type = 'order') => {
  if (type === 'all_orders') {
    return [
      {
        title: "PO Status",
        filter_key: "po_status",
        type: 'checkbox',
        filters: [
          { label: "Pending Acknowledgement", value: "pending_acknowledgement" },
          { label: "Confirmed", value: "confirmed" },
          { label: "Revision Requested", value: "revision_requested" },
          { label: "Cancellation Requested", value: "cancellation_requested" },
          { label: "Completed", value: "completed" },
          { label: "Cancelled", value: "cancelled" },
          { label: "Vendor Rejected", value: "vendor_rejected" },
        ],
      },
      {
        title: "Business Unit",
        filter_key: "business_unit",
        type: "text",
        placeholder: "Enter Business Unit",
      },
      {
        title: "Project City",
        filter_key: "project_city",
        type: "select",
        placeholder: "Select City",
      },
      {
        title: "Vendor invoice status",
        filter_key: "invoice_status",
        type: 'checkbox',
        filters: [
          { label: "Pending", value: "pending" },
          { label: "Request for submission", value: "request_for_submission" },
          { label: "Completed", value: "completed" },
        ],
      },
    ];
  }
  if (type === 'order') {
    return [
      {
        title: "PO confirmed date",
        type: 'rangeDate',
        filters: [
          {
            label: "From date",
            filterKey: "start_date",
          },
          {
            label: "To date",
            filterKey: "end_date"
          },
        ],
      },
      {
        title: "Project ID",
        filter_key: "project_id",
        type: "text",
        placeholder: "Enter Project ID",
      },
      {
        title: "Business Unit",
        filter_key: "business_unit",
        type: "text",
        placeholder: "Enter Business Unit",
      },
      {
        title: "Project City",
        filter_key: "project_city",
        type: "select",
        placeholder: "Select City",
      },
      {
        title: "Vendor invoice status",
        filter_key: "invoice_status",
        type: 'checkbox',
        filters: [
          {
            label: "Pending",
            value: "pending",
          },
          {
            label: "Request for submission",
            value: "request_for_submission",
          },
          {
            label: "Completed",
            value: "completed",
          },
        ],
      },
      {
        title: "View orders",
        filter_key: "exception_invoice",
        type: 'checkbox',
        filters: [
          {
            label: "With invoice exception",
            value: "true",
          },
          {
            label: "Without invoice exception",
            value: "false",
          },
        ],
      },
      {
        title: "GRN Status",
        filter_key: "grn_done",
        type: 'checkbox',
        filters: [
          {
            label: "Successful",
            value: "true",
          },
          {
            label: "Pending",
            value: "false",
          },
        ],
      },
      {
        title: "Invoice Uploaded",
        filter_key: "invoice_uploaded",
        type: 'checkbox',
        filters: [
          {
            label: "Uploaded",
            value: true,
          },
          {
            label: "Not uploaded",
            value: false,
          },
        ],
      },
      {
        title: "L1 validation status",
        filter_key: "l1_validation_status",
        type: 'checkbox',
        filters: [
          {
            label: "Pending",
            value: "pending",
          },
          {
            label: "Approved",
            value: "approved",
          },
          {
            label: "Rejected",
            value: "rejected",
          },
        ],
      },
      {
        title: "L2 validation status",
        filter_key: "l2_validation_status",
        type: 'checkbox',
        filters: [
          {
            label: "Pending",
            value: "pending",
          },
          {
            label: "Approved",
            value: "approved",
          },
          {
            label: "Rejected",
            value: "rejected",
          },
        ],
      },
      {
        title: "Info Status",
        type: "checkbox",
        filter_key: "is_pending_info",
        filters: [
          {
            label: "Pending",
            value: true
          },
        ],
      }
    ]
  } else {
    return [
      {
        title: "Business Unit",
        filter_key: "business_unit",
        type: "text",
        placeholder: "Enter Business Unit",
      },
      {
        title: "Project City",
        filter_key: "project_city",
        type: "select",
        placeholder: "Select City",
      },
      {
        title: "Vendor invoice status",
        filter_key: "invoice_status",
        type: 'checkbox',
        filters: [
          {
            label: "Pending",
            value: "pending",
          },
          {
            label: "Request for submission",
            value: "request_for_submission",
          },
          {
            label: "Completed",
            value: "completed",
          },
        ],
      }, 
      {
        title: "Invoice date",
        type: 'rangeDate',
        filters: [
          {
            label: "From date",
            filterKey: "start_date",
          },
          {
            label: "To date",
            filterKey: "end_date"
          },
        ],
      },
      {
        title: "Invoice validation status",
        filter_key: "validation_status",
        type: 'checkbox',
        filters: [
          {
            label: "Auto validated invoices",
            value: "auto",
          },
          {
            label: "Require manual review",
            value: "manual",
          }
        ],
      }, 
    ]
  }
}
